//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Report.js";
import "../no/Object.js";
import "../Report/Report.ReportManager.js";
let d=[[],[[["message"],"LogMessage",{},1,0],[["message","messageType"],"LogmessageBytype",{},2,0],[[],"Clear",{},0,0],[["logFileName"],"SaveLog",{},1,0],[[],"IsEmpty",{R_:{empty:''}},0,0]],[]];
SPLM.Report.AutomationLogger = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Report.AutomationLogger";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Report.AutomationLogger.MessageType = Object.freeze({
    "Empty" : "Empty", "Information" : "Information", "Debug" : "Debug", "Exception" : "Exception"});

export default SPLM;